import { render } from "./AanmeldBlock.vue?vue&type=template&id=6ca73a65&scoped=true"
import script from "./AanmeldBlock.vue?vue&type=script&lang=js"
export * from "./AanmeldBlock.vue?vue&type=script&lang=js"

import "./AanmeldBlock.vue?vue&type=style&index=0&id=6ca73a65&lang=scss&scoped=true"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca73a65"]])

export default __exports__